import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

export interface CategoryListItem {
  uuid: string;
  name: string;
  /**
   * Whether this category is one the step editor's standing warning is about —
   * its own label is not properly defined, or one of its options' is. Decided
   * by the facade from the domain objects; this component only renders it.
   */
  undefinedLabel?: boolean;
}

@Component({
  selector: 'ts-category-management-list',
  templateUrl: './category-management-list.component.html',
  styleUrls: ['./category-management-list.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, DragDropModule, MatProgressSpinnerModule],
})
export class CategoryManagementListComponent {
  @Input() items: CategoryListItem[] = [];
  @Input() canEdit = true;
  @Input() canAdd = true;
  @Input() loading = true;
  @Input() titleKey = 'pipeline_step_editor.categories.title';
  @Input() descriptionKey = 'pipeline_step_editor.categories.description';

  @Output() addClicked = new EventEmitter<void>();
  @Output() editClicked = new EventEmitter<CategoryListItem>();
  @Output() visualizeClicked = new EventEmitter<CategoryListItem>();
  @Output() removeConfirmed = new EventEmitter<CategoryListItem>();
  @Output() reordered = new EventEmitter<CategoryListItem[]>();

  pendingRemovalUuid: string | null = null;

  trackByUuid(_: number, item: CategoryListItem): string {
    return item.uuid;
  }

  requestRemove(item: CategoryListItem): void {
    this.pendingRemovalUuid = item.uuid;
  }

  confirmRemove(item: CategoryListItem): void {
    this.pendingRemovalUuid = null;
    this.removeConfirmed.emit(item);
  }

  cancelRemove(): void {
    this.pendingRemovalUuid = null;
  }

  onDrop(event: CdkDragDrop<CategoryListItem[]>): void {
    if (!this.canEdit) return;
    if (event.previousIndex === event.currentIndex) return;

    const next = [...this.items];
    moveItemInArray(next, event.previousIndex, event.currentIndex);
    this.reordered.emit(next);
  }
}
